/**
 * ⌘K palette recents — the last commands run, persisted per browser
 * profile, the way native palettes (Spotlight, Raycast) remember history.
 *
 * Plain localStorage: this is non-critical UX sugar, so private-mode or
 * storage-denied environments silently degrade to "no recents".
 */

const STORAGE_KEY = 'bbx.commandBar.recents';
const MAX_RECENTS = 5;

export function loadCommandRecents(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is string => typeof v === 'string').slice(0, MAX_RECENTS);
  } catch {
    return [];
  }
}

/** Record an executed command (most recent first, deduped, capped). */
export function pushCommandRecent(id: string): string[] {
  const next = [id, ...loadCommandRecents().filter((v) => v !== id)].slice(0, MAX_RECENTS);
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Storage unavailable — recents just won't persist.
  }
  return next;
}
